import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react'
import {    CCardBody,  CButton,  CAccordion,  CAccordionItem,  CAccordionHeader,  CAccordionBody,  CSpinner,    CTableDataCell,  CFormLabel,  CTooltip,  CModal,  CModalHeader,  CModalTitle,  CModalBody,  CModalFooter} from '@coreui/react'
import {  CalendarDays, FilePenLineIcon, Filter, LogOutIcon, SearchIcon, Table2, X } from 'lucide-react'
import { motion } from 'framer-motion'
import FacilityCRUD from '../../services/general/getFacilityData.api'
import SavePatients from '../../../src/services/general/savePatientinformation.api'
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import { getAllAppointments, getAllAppointmentsDetails, getAppointmentDataID } from '../../../src/components/shared/appointmentFilterData'
import PatientPopup from './PatientPopup'
import Button from '@mui/material/Button'
import Pageloader from '../../components/shared/Pageloader'
import toast from 'react-hot-toast'
import { toastConfig } from '../../../src/constants/other.config.js'
import CustomDatePickingFormat from '../../../src/components/shared/CustomDatePickingFormat'
import AppSelect from '../../components/shared/AppSelect'
import { FunnelPlotOutlined } from '@ant-design/icons'
import PatientSuperBillData from '../../../src/services/general/patientSuperBill.api'
import LastVisited from '../../assets/images/lastVisitedIcon.svg'
import fetchPatientData from '../../services/general/patientGeneralAPI.api'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import MedicineCRUD from '../../services/general/Medication.api'
import PatientMedications from '../../services/general/patientMedicationData.api'
import PatientAppointmentDetails from '../../services/general/appointmentData.api'
import { getFacilityParentCompany, getPatientFacilityParentCompany } from '../../utils/facilityParentCompany'
import { areSameDateValues } from '../../components/shared/customDateFormatUtils'
import { patientMatchesSearch } from '../../utils/searchUtils'

const DEFAULT_FILTERS = {
  facility: [],
  diagnosis: '',
  medication: '',
  patientType: '',
  patientStatus: '',
  noteStatus: '',
  appointmentStatus: '',
  dob: '',
}

const DashboardFacility = ({ type }) => {
  const [facilityData, setFacilityData] = useState([])
  const [loading, setLoading] = useState(false)
  const [patientData, setPatientData] = useState([])
  const [patientNotes, setPatientNotes] = useState({})
  const openedFacilitiesRef = useRef(new Set())
  const [expandedFacilities, setExpandedFacilities] = useState(() => new Set())
  const [appointments, setAppointments] = useState([])
  const [viewPatientDetail, setViewPatientDetail] = useState(null)
  const [showFilters, setShowFilters] = useState(false)
  const [filters, setFilters] = useState(DEFAULT_FILTERS)
  const [appliedFilters, setAppliedFilters] = useState(DEFAULT_FILTERS)
  const [searchQuery, setSearchQuery] = useState('')
  const [dischargingPatient, setDischargingPatient] = useState(null)
  const [patientID, setPatientID] = useState('')
  const [patientIDClicked, setPatientIDClicked] = useState(-1)
  const [rowClicked, setRowClicked] = useState(null)
  const [selectedFacility, setSelectedFacility] = useState({})
  const [patientModelVisible, setPatientModalVisible] = useState(false)

  const [creatingNewNote, setCreatingNewNote] = useState(false)
  const [noteStatus, setNoteStatus] = useState('New Note')
  const [noteID, setNoteID] = useState(null)
  const [dataCallType, setDataCallType] = useState(null)
  const [setDataId, setEditDataId] = useState(null)
  const [showPatientInfo, setShowPatientInfo] = useState(false)
  const [allSelectedDiagnosis, setAllSelectedDiagnosis] = useState([])
  const [patientAppointmentID, setPatientAppointmentID] = useState(null)
  const [allAppointment, setAllAppointment] = useState([])
  const [roomNumber, setRoomNumber] = useState('')
  const [addedInsurances, setAddedInsurances] = useState([])
  const [diagnosisData, setDiagnosisData] = useState([])
  const [medicationData, setMedicationData] = useState([])
  const [insuranceList, setInsuranceList] = useState([])
  const [insuranceTypes, setInsuranceTypes] = useState([])
  const [patientMedicationMap, setPatientMedicationMap] = useState({})
  const [medicationFilterLoading, setMedicationFilterLoading] = useState(false)
  const [noteFilterLoading, setNoteFilterLoading] = useState(false)
  const [facilityLoadingMap, setFacilityLoadingMap] = useState({})

  const patientMedicationDatasetKey = useMemo(
    () => patientData.map((patient) => String(patient?.PatientID || '')).filter(Boolean).sort().join('|'),
    [patientData],
  )

  const [isPageLoading, setIsPageLoading] = useState(false)
  const [medicationsLoading, setMedicationsLoading] = useState(true)
  const [diagnosesLoading, setDiagnosesLoading] = useState(true)
  const [patientsLoading, setPatientsLoading] = useState(true)
  const [appointmentsLoading, setAppointmentsLoading] = useState(true)
  const [isNotesPreloading, setIsNotesPreloading] = useState(true)
  const [patientAppointment, setPatientAppointment] = useState([])

  const [childformData, setChildFormData] = useState({
    FirstName: '',
    MiddleName: '',
    LastName: '',
    DOB: '',
    Gender: '',
    Age: '0',
    PhoneNumber: '',
    EmergencyName: '',
    EmergencyPhone: '',
    Address: '',
    State: '',
    City: '',
    ZipCode: '',
    Country: '',
    insurance: '',
  })

  const loadDiagnosisOptions = useCallback(async () => {
    setDiagnosesLoading(true)
    try {
      const response = await GetDiagnosisData()
      const data = JSON.parse(response.d)
      const options = Array.from(
        new Map(
          (data?.Data || [])
            .map((obj) => {
              const label = obj?.Name?.trim()
              if (!label) return null

              return [
                String(label).trim().toLowerCase(),
                {
                  value: obj.id,
                  label,
                },
              ]
            })
            .filter(Boolean),
        ).values(),
      ).sort((a, b) => a.label.localeCompare(b.label))

      setDiagnosisData(options)
    } catch (error) {
      console.error('Error loading diagnoses:', error)
      setDiagnosisData([])
    } finally {
      setDiagnosesLoading(false)
    }
  }, [])

 const loadMedicationOptions = useCallback(async () => {
  setMedicationsLoading(true)
  try {
    const response = await MedicineCRUD('GET')
    const data = JSON.parse(response.d)

    const options = Array.from(
      new Map(
        (data?.Data || [])
          .map((item) => {
            const medication =
              typeof item?.Data === 'string'
                ? JSON.parse(item.Data)
                : item?.Data || {}

            const name = String(medication?.name || '').trim()
            const otherName = String(
              medication?.otherName || medication?.othername || ''
            ).trim()

            if (!name && !otherName) return null

            return [
              `${name}-${otherName}`.toLowerCase(),
              {
                value: item.ID || item.Id,
                label: otherName
                  ? `${name} (${otherName})`
                  : name,
                name,
                otherName,
              },
            ]
          })
          .filter(Boolean)
      ).values()
    ).sort((a, b) => a.label.localeCompare(b.label))

    setMedicationData(options)
  } catch (error) {
    console.error('Error loading medications:', error)
    setMedicationData([])
  } finally {
    setMedicationsLoading(false)
  }
}, [])

  const getData = useCallback(async () => {
    await loadDiagnosisOptions()
    await loadMedicationOptions()

    let insuranceData = await fetchPatientData('GET', 'Insurance', '{}')
    insuranceData = JSON.parse(insuranceData.d)?.Data

    const uniqueInsuranceTypes = Array.from(new Set(insuranceData.map((ins) => ins.Type)))
    setInsuranceList(insuranceData)
    setInsuranceTypes(uniqueInsuranceTypes)
  }, [loadDiagnosisOptions, loadMedicationOptions])

  const patientSelected = async (rowSelected) => {
    getData()
    setViewPatientDetail(rowSelected)

    let patientInsurance = await PatientInsuranceFn('SELECTALL', '', rowSelected.PatientID)

    try {
      patientInsurance = JSON.parse(patientInsurance.d)?.Data
    } catch (e) {}

    try {
      const tempSelectedDiagnosis = rowSelected.Diagnosis ? rowSelected.Diagnosis.split(',') : []
      const selectedDiagnosis = diagnosisData.filter((obj) => tempSelectedDiagnosis.includes(obj.label))
      setRoomNumber(rowSelected?.Room)
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
      setSelectedFacility(userFacilities ? userFacilities : facilities[0])
      setAllSelectedDiagnosis(selectedDiagnosis)
    } catch (e) {
      setAllSelectedDiagnosis([])
    }

    setChildFormData({
      FirstName: rowSelected.FirstName || '',
      MiddleName: rowSelected.MiddleName || '',
      LastName: rowSelected.LastName || '',
      DOB: rowSelected.DOB || '',
      Gender: rowSelected.Gender || '',
      Age: rowSelected.Age || '0',
      PhoneNumber: rowSelected.PhoneNumber || '',
      EmergencyName: rowSelected.EmergencyName || '',
      EmergencyPhone: rowSelected.EmergencyPhone || '',
      Address: rowSelected.Address || '',
      State: rowSelected.State || '',
      City: rowSelected.City || '',
      ZipCode: rowSelected.ZipCode || '',
      Country: rowSelected.Country || '',
    })

    setSelectedDetails({ Insurances: patientInsurance })
  }

  const handleAddNoteId = async (noteID) => {
    try {
      setIsPageLoading(true)

      const groupedData = []

      const selectedAppointments = appointments.filter((item) => item?.data?.AppointmentID === patientAppointmentID)
      if (selectedAppointments.length === 0) {
        cosnole.error('appointment note found')
      }

      const appointment = selectedAppointments[0]

      const latestData = await getAllAppointmentsDetails('GETBYSCHEDULEDATEANDPROVIDERID', appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value)

      let appointmentFilterData = latestData.map((item) => {
        if (item.data.AppointmentID === patientAppointmentID) {
          return {
            ...item,
            data: {
              ...item.data,
              NoteID: noteID,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      const ID = await getAppointmentDataID('GETBYSCHEDULEDATEANDPROVIDERID', appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value)

      if (ID) {
        await PatientAppointmentDetails('UPDATE', ID, appointment.data.StartTime.split(' ')[0], appointment?.current?.Provider?.value, JSON.stringify(groupedData))
      } else {
        toast.error('Appointment ID note found', toastConfig)
      }
      // await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      getAppointmentData()
      patientDataFn()

      // toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save Note Id', toastConfig)
      console.log('error', error)
    } finally {
      setIsPageLoading(false)
      setPatientAppointment([])
    }
  }

  const filterRef = useRef(null)
  const noteStructureRef = useRef({})
  const medicationRecordCacheRef = useRef({})
  const patientNoteFetchPromiseRef = useRef({})
  const patientMedicationFetchPromiseRef = useRef({})
  const patientNotesRef = useRef({})
  const medicationFilterRequestRef = useRef(null)
  const medicationFilterLoadedDatasetRef = useRef('')

  const fetchNotesForPatientIds = useCallback(
    async (patientIds) => {
      const uniquePatientIds = Array.from(new Set((patientIds || []).filter(Boolean).map(String)))
      const idsToFetch = uniquePatientIds.filter((patientID) => !patientNotesRef.current?.[patientID])

      if (idsToFetch.length === 0) return {}

      const fetchNoteForPatient = (patientID) => {
        if (patientNoteFetchPromiseRef.current[patientID]) {
          return patientNoteFetchPromiseRef.current[patientID]
        }

        const promise = (async () => {
          try {
            const response = await PatientNoteDataCRUD('GET', patientID)
            const parsed = JSON.parse(response?.d || '{}')
            const notes = Array.isArray(parsed?.Data)
              ? parsed.Data.map((item) => ({
                  ...item,
                  data: item?.data
                    ? typeof item.data === 'string'
                      ? JSON.parse(item.data)
                      : item.data
                    : {},
                }))
              : []
            return { patientID, notes }
          } catch (error) {
            console.error('Error fetching patient notes for', patientID, error)
            return { patientID, notes: [] }
          } finally {
            delete patientNoteFetchPromiseRef.current[patientID]
          }
        })()

        patientNoteFetchPromiseRef.current[patientID] = promise
        return promise
      }

      const NOTE_BATCH_SIZE = 128
      const results = []
      for (let index = 0; index < idsToFetch.length; index += NOTE_BATCH_SIZE) {
        const batch = idsToFetch.slice(index, index + NOTE_BATCH_SIZE)
        const batchResults = await Promise.all(batch.map(fetchNoteForPatient))
        results.push(...batchResults)
      }
      const fetchedNotes = {}
      results.forEach(({ patientID, notes }) => {
        if (patientID) fetchedNotes[patientID] = notes
      })

      if (Object.keys(fetchedNotes).length > 0) {
        setPatientNotes((prev) => {
          const next = { ...prev, ...fetchedNotes }
          patientNotesRef.current = next
          return next
        })
      }

      return fetchedNotes
    },
    [],
  )

  const [patientTreatments, setPatientTreatments] = useState([])
  const [facilities, setFacilities] = useState([])
  const selectStatusOption = [
    { value: 'NewPatient', label: 'New Patient' },
    { value: 'Follow Up', label: 'Follow Up' },
    { value: 'Re Admit', label: 'Re Admit' },
  ]

  const patientTypeOptions = [
    { value: '', label: 'All Patients' },
    { value: 'Long Term', label: 'Long Term' },
    { value: 'Short Term', label: 'Short Term' },
  ]

  
  const uniqueNoteStatuses = ['Draft', 'Submitted', 'Pending', 'Completed']
  const isLoadingData = loading || patientData.length === 0
   const [superBillMap, setSuperBillMap] = useState({})
  const normalizeDiagnosisValue = useCallback((value) => String(value || '').trim().toLowerCase(), [])
  const normalizeMedicationValue = useCallback((value) => String(value || '').trim().toLowerCase(), [])
  const normalizePatientTypeValue = useCallback((value) => String(value || '').trim().toLowerCase(), [])

  const appointmentsByPatientId = useMemo(() => {
    return appointments.reduce((acc, appointment) => {
      const patientId = String(appointment?.data?.PatientID || '')
      if (!patientId) return acc

      if (!acc[patientId]) {
        acc[patientId] = []
      }

      acc[patientId].push(appointment)
      return acc
    }, {})
  }, [appointments])

  const latestAppointmentByPatientId = useMemo(() => {
    return Object.entries(appointmentsByPatientId).reduce((acc, [patientId, patientAppointments]) => {
      acc[patientId] = [...patientAppointments].sort((a, b) => new Date(b?.data?.StartTime || 0) - new Date(a?.data?.StartTime || 0))[0] || null
      return acc
    }, {})
  }, [appointmentsByPatientId])

  const patientsByFacility = useMemo(() => {
    const groupedPatients = patientData.reduce((acc, patient) => {
      const facilityName = String(patient?.FacilityName || '').trim()
      if (!facilityName) return acc

      if (!acc[facilityName]) {
        acc[facilityName] = []
      }

      acc[facilityName].push({
        ...patient,
        facilityParentCompany: getPatientFacilityParentCompany(patient, facilityData),
      })

      return acc
    }, {})

    Object.keys(groupedPatients).forEach((facilityName) => {
      groupedPatients[facilityName].sort((a, b) => {
        const firstA = String(a?.FirstName || '').trim().toLowerCase()
        const firstB = String(b?.FirstName || '').trim().toLowerCase()
        return firstA.localeCompare(firstB)
      })
    })
    return groupedPatients
  }, [patientData, facilityData])

  const normalizeMedicationComparisonValue = useCallback(
    (value) =>
      normalizeMedicationValue(value)
        .replace(/[^a-z0-9]/g, '')
        .replace(/ph/g, 'f'),
    [normalizeMedicationValue],
  )

  const getPatientDiagnosisLabels = useCallback((patient) => {
    const diagnosisValue = patient?.Diagnosis

    if (Array.isArray(diagnosisValue)) {
      return diagnosisValue
        .map((entry) => {
          if (typeof entry === 'string') return entry.trim()
          if (entry && typeof entry === 'object') {
            return String(entry.label || entry.value || entry.Name || '').trim()
          }
          return ''
        })
        .filter(Boolean)
    }

    if (typeof diagnosisValue === 'string') {
      return diagnosisValue
        .split(',')
        .map((entry) => entry.trim())
        .filter(Boolean)
    }
    return []
  }, [])

  const getPatientMedicationLabels = useCallback(
    (patient) => {
      const patientId = String(patient?.PatientID || '')
      if (!patientId) return []
      return patientMedicationMap[patientId] || []
    },
    [patientMedicationMap],
  )

  const patientTypeMap = useMemo(() => {
    return appointments.reduce((acc, appointment) => {
      const patientId = String(appointment?.data?.PatientID || '')
      const patientType = String(appointment?.data?.term || '').trim()
      if (!patientId || !patientType) return acc

      const currentStart = new Date(appointment?.data?.StartTime || 0).getTime()
      const previous = acc[patientId]
      const previousStart = new Date(previous?.startTime || 0).getTime()

      if (!previous || currentStart >= previousStart) {
        acc[patientId] = {
          term: patientType,
          startTime: appointment?.data?.StartTime || '',
        }
      }

      return acc
    }, {})
  }, [appointments])

  const getPatientType = useCallback(
    (patient) => {
      const patientId = String(patient?.PatientID || '')
      return patientTypeMap[patientId]?.term || ''
    },
    [patientTypeMap],
  )

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (filterRef.current && !filterRef.current.contains(e.target)) {
        setShowFilters(false)
      }
    }
    if (showFilters) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [showFilters])

 

  useEffect(() => {
    loadDiagnosisOptions()
  }, [loadDiagnosisOptions])

  useEffect(() => {
    loadMedicationOptions()
  }, [loadMedicationOptions])

  useEffect(() => {
    patientNotesRef.current = patientNotes
  }, [patientNotes])

  useEffect(() => {
    setPatientMedicationMap({})
    medicationRecordCacheRef.current = {}
    medicationFilterRequestRef.current = null
    medicationFilterLoadedDatasetRef.current = ''
  }, [patientMedicationDatasetKey])

  
  useEffect(() => {
    if (rowClicked?.PatientID) {      
      GetPatientTreatmentsNotes()
    }
  }, [rowClicked])

 

  const getPatientAppointment = useCallback(
    (patientID) => {
      return appointmentsByPatientId[String(patientID || '')] || []
    },
    [appointmentsByPatientId],
  )

  useEffect(() => {
    getFacilities()
    patientDataFn()
    getAppointmentData()
  }, [type])

  
  const getFacilities = async () => {
    setLoading(true)
    try {
      const res = await FacilityCRUD('SELECT', {})
      const parsed = JSON.parse(res.d)
      let data = parsed?.Data || []
      data = data.sort((a, b) =>
        (a.Name || '')
          .trim()
          .replace(/\s+/g, ' ')
          .toLowerCase()
          .localeCompare((b.Name || '').trim().replace(/\s+/g, ' ').toLowerCase()),
      )
      if (type) {
        data = data.filter((item) => item.Type === type)
      }        
      setFacilityData(data)
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const getAppointmentData = async () => {
    setAppointmentsLoading(true)
    try {
      const structureData = await getAllAppointments('GET')
      const flatAppointments = structureData.flatMap((p) => p?.appointmentDetails || [])
      console.log('FLAT APPOINTMENTS:', flatAppointments)
      setAppointments(flatAppointments)
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
      setAppointmentsLoading(false)
    }
  }

  const patientDataFn = async () => {
    setPatientsLoading(true)
    try {
      const res = await SavePatients('GetAll', '', '', '')
      const parsed = JSON.parse(res.d)
      setPatientData(parsed?.Data || [])

      console.log('patientDataFn for colour', patientData)
    } catch (error) {
      console.error(error)
    } finally {
      setPatientsLoading(false)
    }
  }

  // Preload patient notes in the background once patient data has loaded
  useEffect(() => {
    let active = true
    if (patientData && patientData.length > 0) {
      setIsNotesPreloading(true)
      const patientIds = patientData.map((patient) => String(patient?.PatientID || '')).filter(Boolean)
      fetchNotesForPatientIds(patientIds).then(() => {
        if (active) {
          setIsNotesPreloading(false)
        }
      }).catch((e) => {
        console.error("Notes preloading failed:", e)
        if (active) {
          setIsNotesPreloading(false)
        }
      })
    } else if (patientData && patientData.length === 0 && !patientsLoading) {
      setIsNotesPreloading(false)
    }
    return () => {
      active = false
    }
  }, [patientData, fetchNotesForPatientIds, patientsLoading])
 
  const getPatientsByFacility = useCallback(
    (facilityName) => {
      if (!facilityName) return []
      return patientsByFacility[facilityName.trim()] || []
    },
    [patientsByFacility],
  )
 
  const savePatientRecord = async (customData) => {
    const patientID = customData?.PatientID
    if (!patientID) return

    let a = {}
    let facility = await patientSelectedFacility(customData)
    try {
      a['FacilityID'] = facility?.value.toString() || selectedFacility?.value.toString()
      a['FacilityName'] = facility?.label.toString() || selectedFacility?.label.toString()
      a['Room'] = customData?.Room?.toString() || roomNumber.toString()
    } catch (e) {
      a['FacilityID'] = ''
      a['FacilityName'] = ''
      a['Room'] = -1
    }
    let allDiagnosis = customData?.Diagnosis || ''
    let insurances = addedInsurances.map((ins) => ({ InsuranceID: ins?.ID }))
    await SavePatients('Update', JSON.stringify(customData), JSON.stringify(a), allDiagnosis, patientID, JSON.stringify(insurances))
    await patientDataFn()
    await getAppointmentData()
  }

  const saveDiagnosisData = async (updateData) => {
    try {
      await savePatientRecord(updateData)
    } catch (error) {
      console.error('Error updating patient:', error)
      toast.error('An error occurred while updating the patient. Please try again.', toastConfig)
    }
  }

  const dischargePatient = async (patient) => {
    try {
      await savePatientRecord({ ...patient, Status: 'Discharge' })
      toast.success('Patient discharged successfully.', toastConfig)
    } catch (error) {
      console.error('Error discharging patient:', error)
      toast.error('An error occurred while discharging the patient. Please try again.', toastConfig)
    }
  }

  const GetPatientTreatmentsNotes = async () => {
    try {
      let data
      data = await PatientNoteDataCRUD('GET', viewPatientDetail.PatientID)
      if (data) {
        data = JSON.parse(data.d)?.Data
        data = data?.map((item) => ({
          ...item,
          data: item?.data ? JSON.parse(item?.data) : {},
        }))
        console.log('patientData from dashboardFacility', data)
        setPatientTreatments(data)       
   
      }
    } catch (error) {
      console.error('Error fetching patient orders', error)
    }
  }

  const handleDischargePatient = (patient) => {
    console.log('discharge1', patient?.PatientID)
    dischargePatient(dischargingPatient)
    setDischargingPatient(null)
  }

  const patientSelectedFacility = async (rowSelected) => {
    try {
      const facilitiesList = await FacilityCRUD('SELECT', {})
      const parsed = JSON.parse(facilitiesList.d)
      const data = parsed?.Data || []
      const formattedData = data.map((facility) => ({
        value: facility.ID,
        label: facility.Name,
      }))
      const userFacilities = formattedData.find((item) => item.label === rowSelected?.FacilityName)
      return userFacilities ? userFacilities : formattedData[0]
    } catch (e) {
      return { value: '', label: '' }
    }
  }

  const getSuperBillData = useCallback(
    async (patientID) => {
      try {
        if (!patientID) return

        // Skip if we already have data for this patient
        if (superBillMap[patientID] !== undefined) {
          return
        }

        console.log(`Fetching super bill data for patient ${patientID}`)

        let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', patientID.toString())

        if (!data || !data.d) {
          setSuperBillMap((prev) => ({ ...prev, [patientID]: [] }))
          return
        }

        let parsedData
        try {
          parsedData = JSON.parse(data.d)
        } catch (parseError) {
          console.error(`JSON parse error for patient ${patientID}:`, parseError)
          setSuperBillMap((prev) => ({ ...prev, [patientID]: [] }))
          return
        }

        const responseData = parsedData?.Data || []

        if (!Array.isArray(responseData) || responseData.length === 0) {
          setSuperBillMap((prev) => ({ ...prev, [patientID]: [] }))
          return
        }

        const formattedData = responseData.map((item) => ({
          Id: item.Id,
          Data: item?.JsonData ? JSON.parse(item.JsonData) : {},
        }))

        // Batch multiple updates together
        setSuperBillMap((prev) => ({ ...prev, [patientID]: formattedData }))
      } catch (err) {
        console.error(`Error fetching super bill data for patient ${patientID}:`, err)
        setSuperBillMap((prev) => ({ ...prev, [patientID]: [] }))
      }
    },
    [superBillMap],
  )
   const normalizeDashboardStatus = (status) => String(status || '').trim().toLowerCase()
  const isDashboardDischargedStatus = (status) => ['discharge', 'discharged'].includes(normalizeDashboardStatus(status))
  const hasNonDischargeNoteStatus = (note) => {
    const status = normalizeDashboardStatus(note?.status || note?.Status)
    return !!status && !isDashboardDischargedStatus(status)
  }

  const patientHasDiagnosis = useCallback(
    (patient, diagnosisLabel) => {
      const normalizedDiagnosis = normalizeDiagnosisValue(diagnosisLabel)
      if (!normalizedDiagnosis) return true

      return getPatientDiagnosisLabels(patient).some((diagnosis) => normalizeDiagnosisValue(diagnosis) === normalizedDiagnosis)
    },
    [getPatientDiagnosisLabels, normalizeDiagnosisValue],
  )

  const patientHasMedication = useCallback(
    (patient, selectedMedication) => {
      const filter = normalizeMedicationComparisonValue(selectedMedication)

      if (!filter) return true

      return getPatientMedicationLabels(patient).some((medication) => {
        const name = normalizeMedicationComparisonValue(
          medication.name || medication.label || medication.medicationName || medication
        )

        const otherName = normalizeMedicationComparisonValue(
          medication.otherName || medication.OtherName || medication.othername || medication.label || ''
        )

        return name.includes(filter) || otherName.includes(filter)
      })
    },
    [getPatientMedicationLabels, normalizeMedicationComparisonValue],
  )

  const patientMatchesType = useCallback(
    (patient, selectedPatientType) => {
      const normalizedSelectedType = normalizePatientTypeValue(selectedPatientType)
      if (!normalizedSelectedType) return true
      return normalizePatientTypeValue(getPatientType(patient)) === normalizedSelectedType
    },
    [getPatientType, normalizePatientTypeValue],
  )

  const getMedicationMetadataId = useCallback((note) => {
    const metadata = note?.data?.metadata || note?.data?.metaData || note?.metadata || note?.metaData || {}

 
    return metadata?.medId || metadata?.medicationID || metadata?.medicationId || ''
  }, [])

  const loadPatientMedicationMap = useCallback(() => {
    const datasetKey = patientMedicationDatasetKey
    if (!datasetKey || patientData.length === 0) {
      setMedicationFilterLoading(false)
      return undefined
    }
    if (medicationFilterLoadedDatasetRef.current === datasetKey) {
      setMedicationFilterLoading(false)
      return undefined
    }
    if (medicationFilterRequestRef.current?.datasetKey === datasetKey) {
      return medicationFilterRequestRef.current.promise
    }

    setMedicationFilterLoading(true)
    const request = (async () => {
      try {
      const BATCH_SIZE = 128
      const nextPatientMedicationMap = {}

      const loadPatientMedicationData = async (patient, fetchedBatchNotes) => {
          const patientId = String(patient?.PatientID || '')

          if (!patientId) return [patientId, []]

          try {
            const existingNotes = patientNotesRef.current?.[patientId]
            let patientNotesData = Array.isArray(existingNotes)
              ? existingNotes
              : Array.isArray(fetchedBatchNotes?.[patientId])
              ? fetchedBatchNotes[patientId]
              : []

            if (!patientNotesData.length && !existingNotes) {
              const fetchedNotes = await fetchNotesForPatientIds([patientId])
              patientNotesData = Array.isArray(fetchedNotes[patientId]) ? fetchedNotes[patientId] : []
            }

            const medicationIds = Array.from(
              new Set(
                patientNotesData
                  .map((note) => String(getMedicationMetadataId(note) || '').trim())
                  .filter(Boolean),
              ),
            )

            if (medicationIds.length === 0) {
              return [patientId, []]
            }

            let medicationRecords = medicationRecordCacheRef.current[patientId]
            if (!medicationRecords) {
              if (patientMedicationFetchPromiseRef.current[patientId]) {
                medicationRecords = await patientMedicationFetchPromiseRef.current[patientId]
              } else {
                const promise = (async () => {
                  try {
                    const medicationResponse = await PatientMedications('GET', patientId)
                    const medicationParsed = JSON.parse(medicationResponse?.d || '{}')
                    return Array.isArray(medicationParsed?.Data)
                      ? medicationParsed.Data.map((item) => ({
                          ...item,
                          data: typeof item?.data === 'string' ? JSON.parse(item.data) : Array.isArray(item?.data) ? item.data : [],
                        }))
                      : []
                  } catch (e) {
                    console.error(e)
                    return []
                  } finally {
                    delete patientMedicationFetchPromiseRef.current[patientId]
                  }
                })()
                patientMedicationFetchPromiseRef.current[patientId] = promise
                medicationRecords = await promise
                medicationRecordCacheRef.current[patientId] = medicationRecords
              }
            }

            const medicationNames = medicationIds.flatMap((medicationId) => {
              const matchingRecord = medicationRecords.find((record) => String(record?.id) === String(medicationId))
              if (!matchingRecord || !Array.isArray(matchingRecord.data)) return []

              return matchingRecord.data.map((entry) => ({
                name: entry?.name || entry?.medicationName || '',
                otherName: entry?.otherName || entry?.OtherName || entry?.othername || '',
              }))
            })

            const uniqueMedicationNames = medicationNames.reduce((acc, item) => {
              const key = `${String(item.name).trim().toLowerCase()}|${String(item.otherName).trim().toLowerCase()}`
              if (!acc.map[key]) {
                acc.map[key] = true
                acc.items.push(item)
              }
              return acc
            }, { map: {}, items: [] })

            return [patientId, uniqueMedicationNames.items]
          } catch (error) {
            console.error(`Error loading note medications for patient ${patientId}:`, error)
            return [patientId, []]
          }
      }


      for (let index = 0; index < patientData.length; index += BATCH_SIZE) {
        const batch = patientData.slice(index, index + BATCH_SIZE)
        const batchPatientIds = batch.map((patient) => String(patient?.PatientID || '')).filter(Boolean)
        const fetchedBatchNotes = await fetchNotesForPatientIds(batchPatientIds)
        const patientMedicationResults = await Promise.allSettled(batch.map((patient) => loadPatientMedicationData(patient, fetchedBatchNotes)))

        patientMedicationResults.forEach((result) => {
          if (result.status !== 'fulfilled') return
          const [patientId, medicationNames] = result.value || []
          if (!patientId) return
          nextPatientMedicationMap[patientId] = medicationNames || []
        })
      }

      setPatientMedicationMap(nextPatientMedicationMap)
      medicationFilterLoadedDatasetRef.current = datasetKey
      } finally {
        setMedicationFilterLoading(false)
        if (medicationFilterRequestRef.current?.promise === request) {
          medicationFilterRequestRef.current = null
        }
      }
    })()

    medicationFilterRequestRef.current = { datasetKey, promise: request }
    return request
  }, [fetchNotesForPatientIds, getMedicationMetadataId, patientData, patientMedicationDatasetKey])

  const latestNoteMap = React.useMemo(() => {
    const map = {}
    Object.keys(patientNotes || {}).forEach((patientId) => {
      const notes = patientNotes[patientId]
      if (!notes?.length) return
      map[patientId] = [...notes].sort((a, b) => new Date(b.date) - new Date(a.date))[0]
      console.log(`Latest note for patient ${patientId}:`, {
        status: map[patientId]?.status,
        date: map[patientId]?.date,
        fullNote: map[patientId],
              })
          })
    return map
  }, [patientNotes])

  const latestSignedNoteMap = React.useMemo(() => {
  const map = {}
  Object.keys(patientNotes || {}).forEach((patientId) => {
    const notes = patientNotes[patientId]
    if (!notes?.length) return
    // Only consider notes that have a signedAt value
    const signedNotes = notes.filter((n) => !!n?.data?.signedAt)
    if (!signedNotes.length) return
    // Pick the most recent one among signed notes
    map[patientId] = [...signedNotes].sort(
      (a, b) => new Date(b.date) - new Date(a.date)
    )[0]
  })
  return map
}, [patientNotes])

  useEffect(() => {
    loadPatientMedicationMap()
  }, [patientMedicationDatasetKey, loadPatientMedicationMap])

  useEffect(() => {
    if (!appliedFilters.noteStatus || patientData.length === 0) return

    let isCurrent = true
    const patientIds = patientData.map((patient) => String(patient?.PatientID || '')).filter(Boolean)

    setNoteFilterLoading(true)
    fetchNotesForPatientIds(patientIds).finally(() => {
      if (isCurrent) setNoteFilterLoading(false)
    })

    return () => {
      isCurrent = false
    }
  }, [appliedFilters.noteStatus, patientData, fetchNotesForPatientIds])

  const filterPatients = useCallback(
    (patients) => {
      return patients.filter((patient) => {
        if (appliedFilters.facility && appliedFilters.facility.length > 0) {
          const patientFacility = (patient.FacilityName || '').trim().toLowerCase()
          const matchesFacility = appliedFilters.facility.some((fac) => fac.toLowerCase() === patientFacility)
          if (!matchesFacility) return false
        }

        if (appliedFilters.diagnosis && !patientHasDiagnosis(patient, appliedFilters.diagnosis)) return false

        if (appliedFilters.medication && !patientHasMedication(patient, appliedFilters.medication)) return false

        if (appliedFilters.patientType && !patientMatchesType(patient, appliedFilters.patientType)) return false

        if (appliedFilters.patientStatus && patient.Status !== appliedFilters.patientStatus) return false

        if (appliedFilters.noteStatus) {
          const latestNote = latestNoteMap[patient.PatientID]
          if (!latestNote || latestNote.status !== appliedFilters.noteStatus) return false
        }

        if (appliedFilters.appointmentStatus) {
          const patientAppointments = getPatientAppointment(patient.PatientID)
          const hasMatchingAppointment = patientAppointments.some((apt) => apt?.data?.Status === appliedFilters.appointmentStatus)
          if (!hasMatchingAppointment) return false
        }

        if (appliedFilters.dob && patient.DOB) {
          if (!areSameDateValues(patient.DOB, appliedFilters.dob)) return false
        }

        if (searchQuery.trim()) {
          const extra = {
            facilityName: patient.FacilityName,
            facilityParentCompany: patient.facilityParentCompany || getPatientFacilityParentCompany(patient, facilityData),
          }
          return patientMatchesSearch(patient, searchQuery, extra)
        }

        return true
      })
    },
    [appliedFilters, latestNoteMap, searchQuery, getPatientAppointment, facilityData, patientHasDiagnosis, patientHasMedication, patientMatchesType],
  )

  const formatDate = (date) => {
    if (!date) return ''
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = date.getFullYear()
    return `${mm}/${dd}/${yyyy}`
  }

  const filteredPatientsByFacility = useMemo(() => {
    return facilityData.reduce((acc, facility) => {
      acc[facility.Name] = filterPatients(getPatientsByFacility(facility.Name))
      return acc
    }, {})
  }, [facilityData, getPatientsByFacility, filterPatients])

  const allFilteredPatients = useMemo(() => Object.values(filteredPatientsByFacility).flat(), [filteredPatientsByFacility])

  const hasVisibleFacilities = useMemo(() => {
    return facilityData.some((facility) => {
      if (appliedFilters.facility && appliedFilters.facility.length > 0 && !appliedFilters.facility.includes(facility.Name)) {
        return false
      }

      return (filteredPatientsByFacility[facility.Name] || []).length > 0
    })
  }, [facilityData, appliedFilters.facility, filteredPatientsByFacility])

  const patientCount = useMemo(() => allFilteredPatients.length, [allFilteredPatients])

  const patientInfoCount = useMemo(
    () => ({
      newPatient: allFilteredPatients.filter((p) => p.Status === 'NewPatient').length,
      followUp: allFilteredPatients.filter((p) => p.Status === 'Follow Up').length,
    }),
    [allFilteredPatients],
  )

  const openTreatmentNote = (patient, appointmentID) => {
    console.log('sdncjsdc', patient, appointmentID)
    setPatientID(patient?.PatientID)
    localStorage.setItem('setPatientIDLocal', patient?.PatientID)
    setPatientIDClicked(patient?.PatientID)
    localStorage.setItem('setPatientIDClickedLocal', patient?.PatientID)
    setRowClicked(patient)
    localStorage.setItem('setRowClickedLocal', JSON.stringify(patient))
    setPatientModalVisible(true)
    localStorage.setItem('setPatientModalVisibleLocal', true)
    setViewPatientDetail(patient)
    setPatientAppointmentID(appointmentID)
    localStorage.setItem('setPatientAppointmentIDLocal', appointmentID)
    localStorage.setItem('setEditDataIdLocal', setDataId)
  }
  

  const uniquePatientStatuses = useMemo(() => {
    const statuses = new Set(patientData.map((p) => p.Status).filter(Boolean))
    return Array.from(statuses)
  }, [patientData])

  const uniqueAppointmentStatuses = useMemo(() => {
    const statuses = new Set(appointments.map((apt) => apt?.data?.Status).filter(Boolean))
    return Array.from(statuses)
  }, [appointments])

  const fetchBatchSuperBillData = useCallback(
    async (patientIds) => {
      const promises = patientIds.map((id) => getSuperBillData(id))
      await Promise.allSettled(promises)
    },
    [getSuperBillData],
  )

  // Optimize fetchNotesForFacility to batch super bill data fetching
  const fetchNotesForFacility = useCallback(
    async (facilityName, currentPatientData) => {
      if (openedFacilitiesRef.current.has(facilityName)) return
      openedFacilitiesRef.current.add(facilityName)

      const patients = (currentPatientData || []).filter((p) => (p.FacilityName || '').trim().toLowerCase() === facilityName.trim().toLowerCase())

      if (patients.length === 0) return

      setFacilityLoadingMap((prev) => ({ ...prev, [facilityName]: true }))
      try {
        // Fetch super bill data for all patients in this facility in one batch
        const patientIds = patients.map((p) => p.PatientID)
        await fetchBatchSuperBillData(patientIds)

        // Fetch notes only for patients whose notes are not already loaded.
        await fetchNotesForPatientIds(patientIds)
      } finally {
        setFacilityLoadingMap((prev) => ({ ...prev, [facilityName]: false }))
      }
    },
    [fetchBatchSuperBillData, fetchNotesForPatientIds],
  )

  const handleFacilityToggle = useCallback(
    (facilityKey, facilityName) => {
      const isCurrentlyExpanded = expandedFacilities.has(facilityKey)

      setExpandedFacilities((prev) => {
        const next = new Set(prev)

        if (isCurrentlyExpanded) {
          next.delete(facilityKey)
        } else {
          next.add(facilityKey)
        }

        return next
      })

      if (!isCurrentlyExpanded) {
        fetchNotesForFacility(facilityName, patientData)
      }
    },
    [expandedFacilities, fetchNotesForFacility, patientData],
  )

 

  const hasAnyAppliedFilters = useMemo(() => {
    return Object.values(appliedFilters).some((value) => value && (!Array.isArray(value) || value.length > 0))
  }, [appliedFilters])

  const getDashboardPatientStatusClass = useCallback((patient, latestAppointment) => {
    const appointmentType = String(latestAppointment?.data?.Type || '').trim().toLowerCase()
    const patientStatus = String(patient?.Status || '').trim().toLowerCase()

    if (appointmentType === 'new' || patientStatus === 'newpatient') return 'dashboard-status-np'
    if (appointmentType === 'follow up' || patientStatus === 'follow up') return 'dashboard-status-fu'
    if (appointmentType === 're admit' || patientStatus === 're admit') return 'dashboard-status-ra'
    return 'dashboard-status-default'
  }, [])

  const renderedFacilities = useMemo(() => {
    return facilityData
      .filter((facility) => {
        if (appliedFilters.facility && appliedFilters.facility.length > 0) {
          if (!appliedFilters.facility.includes(facility.Name)) return false
        }
        const patientsInFacility = filteredPatientsByFacility[facility.Name] || []
        const hasMatchingPatients = patientsInFacility.length > 0
        const hasNoActiveFilters = !searchQuery.trim() && !hasAnyAppliedFilters
        return hasMatchingPatients || hasNoActiveFilters
      })
      .map((item, index) => {
        const facilityKey = String(item.ID || item.Name || index)
        const isExpanded = expandedFacilities.has(facilityKey)
        const filteredPatients = filteredPatientsByFacility[item.Name] || []

        if (filteredPatients.length === 0) return null
     
        return (
          <CAccordionItem key={facilityKey} itemKey={facilityKey} className="border-0 border-bottom my-2 mx-4 dashboard-dark-facility-item">
            <CAccordionHeader onClick={() => handleFacilityToggle(facilityKey, item.Name)}>
	              <div className="d-flex justify-content-between align-items-center w-100">
	                <span className="text-primary d-flex align-items-center gap-2 flex-wrap">
	                  <span>
	                    {item.Name}{' '}
	                    {appliedFilters.medication
	                      ? `(${filteredPatients.length} patients on ${appliedFilters.medication})`
	                      : appliedFilters.diagnosis
	                        ? `(${filteredPatients.length} patients with ${appliedFilters.diagnosis})`
	                        : `(${filteredPatients.length})`}{' '}
	                    {getFacilityParentCompany(item) && `- ${getFacilityParentCompany(item)}`}
	                  </span>
	                </span>
	              </div>
            </CAccordionHeader>
            <CAccordionBody className="p-0">
              {isExpanded && facilityLoadingMap[item.Name] ? (
                <div className="d-flex justify-content-center align-items-center py-4" style={{ minHeight: '80px' }}>
                  <CSpinner color="primary" />
                </div>
              ) : isExpanded && filteredPatients.length > 0
                ? filteredPatients.map((patient) => {
                  const latestNote = latestNoteMap[patient.PatientID]
                  const latestSignedNote = latestSignedNoteMap[patient.PatientID]
                 const noteAllowsEdit = hasNonDischargeNoteStatus(latestNote)

                      const rowIsPatientDischarged =
                        isDashboardDischargedStatus(patient?.Status) &&
                        !noteAllowsEdit
                    const latestAppointment = latestAppointmentByPatientId[String(patient.PatientID)] || null
                    const latestAppointmentNoteId = String(latestAppointment?.data?.NoteID || '').trim()
                    const latestAppointmentNote = latestAppointmentNoteId
                      ? (patientNotes?.[patient.PatientID] || []).find((note) => String(note?.id || '') === latestAppointmentNoteId)
                      : null
                    const dashboardNoteStatus = latestAppointment
                      ? latestAppointmentNoteId
                        ? latestAppointmentNote?.status || 'Not Created'
                        : 'Not Created'
                      : latestNote?.status || 'Not Created'
                    const appointmentIDPatient = latestAppointment?.data?.AppointmentID            
                    const patientSuperBill = superBillMap?.[patient.PatientID]
                    const followUpTime = patientSuperBill?.[0]?.Data?.followUpTime
                    const LastDate = patientSuperBill?.[0]?.Data?.PDate                 

                    // Check if super bill data is still loading for this patient
                    const isSuperBillLoading = superBillMap[patient.PatientID] === undefined && patientData.length > 0

                    // Log for debugging
                    if (patientSuperBill !== undefined && patientSuperBill.length > 0) {
                      // console.log(`Patient ${patient.FirstName} ${patient.LastName} (ID: ${patient.PatientID}) has ${patientSuperBill.length} super bill records`)
                      if (followUpTime) {
                        // console.log(`  - FollowUpTime: ${followUpTime}`)
                      }
                    } 
                    // else if (patientSuperBill !== undefined && patientSuperBill.length === 0) {
                    //   console.log(`Patient ${patient.FirstName} ${patient.LastName} (ID: ${patient.PatientID}) has no super bill data`)
                    // }

                    const hasLastVisited = !!latestSignedNote?.data?.signedAt
                    const patientTypeLabel = String(
                      patient?.PatientType || patient?.patientType || getPatientType(patient) || '',
                    ).trim()
                     
                    const hasFollowUp = !!followUpTime                 
                    const hasScheduled = !!latestAppointment?.data?.StartTime
                    const shouldScroll = (hasLastVisited && hasFollowUp) || hasScheduled
                    const patientStatusClass = getDashboardPatientStatusClass(patient, latestAppointment)

                    return (
                      <div
                        key={patient.PatientID}
                        className={`patient-row-list dashboard-dark-patient-row ${patientStatusClass}`}
                        style={{
                          minHeight: '60px',
                          alignItems: 'center',
                          width: '100%',
                          position: 'relative',
                          paddingLeft: '8px',
                          paddingRight: '10px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          gap: '8px',
                          flexWrap: 'nowrap',
                          overflow: 'hidden',
                        }}
                      >
                        {/* align it in the extreme left */}

                        <CTableDataCell className={` border-bottom-0 border-0`} scope="row">
                          <span
                            className="patient-name-fixed-dashboard"
                            style={{
                              display: 'inline-block',
                              maxWidth: '200px', // 👈 control width
                              whiteSpace: 'normal', // ✅ allow wrapping
                              wordBreak: 'break-word', // ✅ break long names properly
                              marginLeft: '20px',
                            }}
                          >
                            {patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}
                          </span>
  </CTableDataCell>             

                        {/* align it in the center - EVENLY ALIGNED COLUMNS */}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '16px',
                            flex: 1,
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            overflowX: 'auto',
                          }}
                        >
                          {/* COL 1: ROOM */}
                          <div style={{ width: '180px', minWidth: '180px', flexShrink: 0 }}>
                            <span
                              className="room-pill"
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                padding: '6px 12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                margin: 0,
                              }}
                            >
                              Room: {patient?.Room}
                            </span>
                          </div>

                          {/* COL 2: DOB */}
                          <div style={{ width: '160px', minWidth: '160px', flexShrink: 0 }}>
                            <span
                              className="notestatus-pill"
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                padding: '6px 12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                margin: 0,
                              }}
                            >
                              DOB: {patient?.DOB || 'N/A'}
                            </span>
                          </div>

                          {/* COL 3: NOTE STATUS */}
                          <div style={{ width: '170px', minWidth: '170px', flexShrink: 0 }}>
                            <span
                              className="room-pill-note-status"
                              style={{
                                fontSize: '12px',
                                fontWeight: '600',
                                padding: '6px 12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                margin: 0,
                              }}
                            >
                              Note: {dashboardNoteStatus}
                            </span>
                          </div>

                          {/* COL 4: PATIENT TYPE */}
                          {patientTypeLabel ? (
                            <div style={{ width: '150px', minWidth: '150px', flexShrink: 0 }}>
                              <span
                                className="patient-type-pill-dashboard"
                                style={{
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  padding: '6px 12px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: '100%',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  margin: 0,
                                }}
                              >
                                {patientTypeLabel}
                              </span>
                            </div>
                          ) : null}

                          {/* COL 5: SCHEDULED DATE */}
                          <div style={{ width: '150px', minWidth: '150px', flexShrink: 0 }}>
                            {hasScheduled ? (
                              <span
                                className="schedule-pill-dashboard"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '6px',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  padding: '6px 12px',
                                  width: '100%',
                                  whiteSpace: 'nowrap',
                                  margin: 0,
                                }}
                              >
                                <CalendarDays style={{ height: '16px', flexShrink: 0 }} />
                                <span>
                                  {latestAppointment?.data?.StartTime?.split(' ')[0]}
                                </span>
                              </span>
                            ) : null}
                          </div>

                          {/* COL 6: FOLLOW UP */}
                          <div style={{ width: '130px', minWidth: '130px', flexShrink: 0 }}>
                            {!isSuperBillLoading && followUpTime ? (
                              <span
                                className="follow-up-pill-dashboard"
                                style={{
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  padding: '6px 12px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: '100%',
                                  whiteSpace: 'nowrap',
                                  margin: 0,
                                }}
                              >
                                F/U: {followUpTime}
                              </span>
                            ) : null}
                          </div>

                          {/* COL 7: LAST VISITED (LAST COLUMN) */}
                          <div style={{ width: '160px', minWidth: '160px', flexShrink: 0 }}>
                            {latestSignedNote?.data?.signedAt ? (
                              <span
                                className="last-visited-pill-dashboard"
                                style={{
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  padding: '6px 12px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  gap: '6px',
                                  width: '100%',
                                  whiteSpace: 'nowrap',
                                  margin: 0,
                                }}
                              >
                                <img
                                  src={LastVisited}
                                  alt="last visited"
                                  style={{
                                    height: '16px',
                                    flexShrink: 0,
                                    filter: 'invert(75%) sepia(74%) saturate(708%) hue-rotate(332deg) brightness(103%) contrast(101%)',
                                  }}
                                />
                                <span>
                                  {formatDate(new Date(latestSignedNote.data.signedAt))}
                                </span>
                              </span>
                            ) : null}
                          </div>
                        </div>

                        {/* align it in the extreme right - RESPONSIVE BUTTONS */}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            gap: '6px',
                            flexShrink: 0,
                          }}
                        >
                          {/* COLUMN 1 → NOTE STATUS */}
                          {/* <span
    className="room-pill"
    style={{
      minWidth: "150px",

    }}
  >
    Note Status: {latestNote?.status || "Not Created"}
  </span> */}

                          {/* COLUMN 2 → BUTTON GROUP */}
                          <div
                            style={{
                              display: 'flex',
                              gap: '6px', // ✅ shrinkable spacing
                              flexShrink: 0, // ✅ prevents breaking
                            }}
                          >
                            <CButton
                              onClick={() => {
                                if (rowIsPatientDischarged) return
                                setDischargingPatient(patient)
                              }}
                              variant="outline"
                              color="dark"
                              className="px-1 py-1 dashboard-dark-icon-button"
                            >
                              <CTooltip content={rowIsPatientDischarged ? 'Already Discharged' : 'Discharge Patient'} placement="top">
                                <span
                                  style={{
                                    cursor: rowIsPatientDischarged ? 'not-allowed' : 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    opacity: rowIsPatientDischarged ? 0.4 : 1,
                                  }}
                                  onClick={() => {
                                    if (rowIsPatientDischarged) return
                                    setDischargingPatient(patient)
                                  }}
                                >
                                  <LogOutIcon size={20} />
                                </span>
                              </CTooltip>
                            </CButton>

                            <CButton onClick={() => openTreatmentNote(patient, appointmentIDPatient)} variant="outline" color="dark" className="px-1 py-1 dashboard-dark-icon-button">
                              <FilePenLineIcon size={20} />
                            </CButton>         
                          </div>
                        </div>

                        {/* <CModal className="dashboard-dark-modal" visible={!!dischargingPatient && dischargingPatient?.PatientID === patient.PatientID && !rowIsPatientDischarged} onClose={() => setDischargingPatient(null)}>
                          <CModalHeader className="dashboard-dark-modal-header">
                            <CModalTitle>Discharge patient</CModalTitle>
                          </CModalHeader>
                          <CModalBody className="dashboard-dark-modal-body">Do you really want to discharge this patient?</CModalBody>
                          <CModalFooter className="dashboard-dark-modal-footer">
                            <CButton className="dashboard-dark-modal-button" variant="outline" color="secondary" onClick={() => setDischargingPatient(null)}>
                              Cancel
                            </CButton>
                            <CButton className="dashboard-dark-modal-button dashboard-dark-modal-button--primary" onClick={() => handleDischargePatient(patient)} variant="outline" color="primary">
                              Discharge Patient
                            </CButton>
                          </CModalFooter>
                        </CModal> */}
                      </div>
                    )
                  })
	                : isExpanded && (searchQuery.trim() || Object.values(appliedFilters).some((value) => value && (!Array.isArray(value) || value.length > 0))) && (
	                    <div className="p-3 text-muted">No patients found matching the filters.</div>
	                  )}
            </CAccordionBody>
          </CAccordionItem>
        )
      })
  }, [facilityData, appliedFilters, searchQuery, superBillMap, patientNotes, latestNoteMap, filteredPatientsByFacility, latestSignedNoteMap, hasAnyAppliedFilters, expandedFacilities, handleFacilityToggle, latestAppointmentByPatientId, getDashboardPatientStatusClass])

  
  return (
    <div className="dashboard-dark-theme dashboard-facility-dark">
      <Pageloader isLoading={loading || isPageLoading || medicationsLoading || diagnosesLoading || patientsLoading || appointmentsLoading || isNotesPreloading || medicationFilterLoading} />
      {/* ─── Header Bar ─── */}
      <CCardBody className="p-2 dashboard-dark-surface dashboard-dark-toolbar" style={{ marginLeft: 15 }}>
        <div className="d-flex align-items-center justify-content-between gap-3">
          <div className="page-header">
            <div className="d-flex  justify-content-between">
              <div className="d-flex align-items-center gap-2">
                {/* Search Input — unchanged */}
                <div className="search-input search-dark dashboard-dark-search">
                  <SearchIcon />
                  <input value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} type="text" placeholder="Search by Patient, Provider or Facility..." />
                </div>

                {/* ─── Filter Button + Popup (exact Appointments2 UI) ─── */}
                <div className="position-relative" ref={filterRef}>
                  <Button className="d-flex align-items-center gap-2 dashboard-dark-filter-button" variant="outlined" size="large" onClick={() => setShowFilters((prev) => !prev)}>
                    <FunnelPlotOutlined />
                    Filter
                  </Button>

                  {showFilters && (
                    <motion.div
                      initial={{ opacity: 0, y: 4 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 4 }}
                      transition={{ duration: 0.3, ease: 'easeInOut' }}
                      style={{
                        width: '400px',
                        zIndex: 50,
                        borderRadius: '10px',
                      }}
                      className="position-absolute gap-1 d-flex flex-column top-full left-0 z-10 shadow-lg p-4 rounded-md dashboard-dark-filter-popover"
                    >
                   
	                      {/* Select Patient Status - Single Select */}
                      <div className="mt-2">
                        <CFormLabel>Select Diagnosis</CFormLabel>
                        <AppSelect
                          placeholder="Select"
                          name="diagnosis"
                          options={diagnosisData}
                          value={diagnosisData.find((opt) => opt.label === filters.diagnosis) || null}
                          isClearable
                          onChange={(selectedOption) => {
                            const val = selectedOption?.label || ''
                            setFilters((prev) => ({ ...prev, diagnosis: val }))
                            setAppliedFilters((prev) => ({ ...prev, diagnosis: val }))
                          }}
                        />
                      </div>

                      <div className="mt-2">
                        <CFormLabel>Select Medication</CFormLabel>
                        <AppSelect
                          placeholder="Select"
                          name="medication"
                          options={medicationData}
                          value={medicationData.find((opt) => opt.name === filters.medication || opt.label === filters.medication) || null}
                          isClearable
                          onChange={(selectedOption) => {
                            const val = selectedOption?.name || selectedOption?.label || ''
                            setFilters((prev) => ({ ...prev, medication: val }))
                            setAppliedFilters((prev) => ({ ...prev, medication: val }))
                          }}
                        />
                      </div>

                      <div className="mt-2">
                        <CFormLabel>Select Patient Type</CFormLabel>
                        <AppSelect
                          placeholder="All Patients"
                          name="patientType"
                          options={patientTypeOptions}
                          value={patientTypeOptions.find((opt) => opt.value === filters.patientType) || patientTypeOptions[0]}
                          onChange={(selectedOption) => {
                            const val = selectedOption?.value || ''
                            setFilters((prev) => ({ ...prev, patientType: val }))
                            setAppliedFilters((prev) => ({ ...prev, patientType: val }))
                          }}
                        />
                      </div>

	                      {/* Select Patient Status - Single Select */}
	                      <div className="mt-2">
	                        <CFormLabel>Select Patient Status</CFormLabel>
                        <AppSelect
                          placeholder="Select"
                          name="patientStatus"
                          options={selectStatusOption}
                          value={selectStatusOption.find((opt) => opt.value === filters.patientStatus) || null}
                          isClearable
                          onChange={(selectedOption) => {
                            const val = selectedOption?.value || ''
                            setFilters((prev) => ({ ...prev, patientStatus: val }))
                            setAppliedFilters((prev) => ({ ...prev, patientStatus: val }))
                          }}
                        />
                      </div>
                   

                      {/* Select Note Status - Single Select */}
                      <div className="mt-2">
                        <CFormLabel>Select Note Status</CFormLabel>
                        <AppSelect
                          placeholder="Select"
                          name="noteStatus"
                          options={uniqueNoteStatuses.map((s) => ({ value: s, label: s }))}
                          value={filters.noteStatus ? { value: filters.noteStatus, label: filters.noteStatus } : null}
                          isClearable
                          onChange={(selectedOption) => {
                            const val = selectedOption?.value || ''
                            setFilters((prev) => ({ ...prev, noteStatus: val }))
                            setAppliedFilters((prev) => ({ ...prev, noteStatus: val }))
                          }}
                        />
                      </div>

                      {/* Select DOB */}
                      <div className="mt-2" style={{ position: 'relative', display: 'inline-block' }}>
                        <CFormLabel>Select DOB</CFormLabel>
                        <div>
                          <CustomDatePickingFormat
                            value={filters.dob || ''}
                            aria-describedby="exampleFormControlInputHelpInline"
                            onChange={(e) => {
                              setFilters((prev) => ({ ...prev, dob: e }))
                              setAppliedFilters((prev) => ({ ...prev, dob: e }))
                            }}
                          />
                        </div>
                      </div>

                      {/* Reset and Close Buttons */}
                      <div className="d-flex gap-2 mt-2">
                        <CButton
                          color="secondary"
                          style={{ flex: 1 }}
                          onClick={() => setShowFilters(false)}
                        >
                          Close
                        </CButton>
                        <CButton
                          color="primary"
                          style={{ flex: 1 }}
                          onClick={() => {
                            setFilters(DEFAULT_FILTERS)
                            setAppliedFilters(DEFAULT_FILTERS)
                          }}
                        >
                          Reset
                        </CButton>
                      </div>
                    </motion.div>
                  )}
                </div>
              </div>
            </div>
          </div>
      

          {/* Right side — Date Pills & Stats */}
          <div className="d-flex align-items-center gap-3">
            {/* Scheduled & Last Visited Date Pills */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '10px',
              }}
            >
              {/* Scheduled */}
              <div
                className="dashboard-dark-pill dashboard-dark-pill--scheduled"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '6px 12px',
                  borderRadius: '20px',
                  fontSize: '13px',
                  fontWeight: '500',
                  width: '180px',
                }}
              >
                <CalendarDays style={{ height: '18px' }} />
                <span>Scheduled Date</span>
              </div>

              {/* Last Visited */}
              <div
                className="last-visited-pill-dashboard2"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '6px 12px',
                  borderRadius: '20px',
                  fontSize: '13px',
                  fontWeight: '500',
                  width: '180px',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                }}
              >
                <img
                  src={LastVisited}
                  alt="last visited"
                  style={{
                    height: '18px',
                    filter: 'invert(75%) sepia(74%) saturate(708%) hue-rotate(332deg) brightness(103%) contrast(101%)',
                  }}
                />
                <span>Last Visited Date</span>
              </div>
            </div>

            <div className="d-flex align-items-center gap-3 mx-3">
              <div className="display-total-patient dashboard-dark-stat">
                <span className="mx-1">{patientCount}</span> Patients
              </div>
              <div className="display-total-patient dashboard-dark-stat">
                <span className="mx-1">{patientInfoCount?.newPatient || 0}</span> NP
              </div>
              <div className="display-total-patient dashboard-dark-stat">
                <span className="mx-1">{patientInfoCount?.followUp || 0}</span> FU
              </div>
            </div>          
          </div>
        </div>
      </CCardBody>
    

      {isLoadingData || (appliedFilters.medication && medicationFilterLoading) || (appliedFilters.noteStatus && noteFilterLoading) ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
          <CSpinner color="primary" />
        </div>
      ) : (
        <>
          {/* ─── No Results Message ─── */}
	          {searchQuery.trim() &&
	            (() => {
              if (!hasVisibleFacilities) {
                return (
	                  <div className="text-center py-5 mx-4">
	                    <div className="text-muted">
	                      <p>
	                        No Data found matching &quot;<strong>{searchQuery}</strong>&quot;
	                      </p>
	                    </div>
	                  </div>
                )
              }
              return null
            })()}

          {!searchQuery.trim() && !hasVisibleFacilities && hasAnyAppliedFilters && (
            <div className="text-center py-5 mx-4">
              <div className="text-muted">No patients found matching the current filters.</div>
            </div>
          )}
         
	          <CAccordion alwaysOpen className="dashboard-dark-accordion">{renderedFacilities}</CAccordion>
        </>
      )}


          <CModal className="dashboard-dark-modal" visible={!!dischargingPatient} onClose={() => setDischargingPatient(null)}>
        <div className="dashboard-dark-theme" style={{ borderRadius: 'var(--cui-modal-border-radius)' }}>
          <CModalHeader className="dashboard-dark-modal-header">
            <CModalTitle>Discharge patient</CModalTitle>
          </CModalHeader>
          <CModalBody className="dashboard-dark-modal-body">
            Do you really want to discharge this patient?
          </CModalBody>
          <CModalFooter className="dashboard-dark-modal-footer">
            <CButton variant="outline" color="secondary" onClick={() => setDischargingPatient(null)}>
              Cancel
            </CButton>
            <CButton color="primary" onClick={() => {
              if (dischargingPatient) handleDischargePatient(dischargingPatient)
            }}>
              Discharge Patient
            </CButton>
          </CModalFooter>
        </div>
      </CModal>

      {/* PatientPopup Modal */}
      <CModal size="lg" visible={patientModelVisible} onClose={() => setPatientModalVisible(false)} className="dashboard-dark-modal">
        <CModalBody className="view-data-modal" style={{ padding: '2rem', borderRadius: '2rem', overflow: 'auto' }}>
          <PatientPopup
            creatingNewNote={creatingNewNote}
            setCreatingNewNote={setCreatingNewNote}
            noteStatus={noteStatus}
            setNoteStatus={setNoteStatus}
            patientSelected={patientSelected}
            setNoteID={setNoteID}
            childformData={childformData}
            setChildFormData={setChildFormData}
            saveDiagnosisData={saveDiagnosisData}
            patientID={patientIDClicked}
            patientData={rowClicked}
            noteStructureRef={noteStructureRef}
            setPatientModalVisible={setPatientModalVisible}
            dataCallType={dataCallType}
            setDataCallType={setDataCallType}
            setEditDataId={setEditDataId}
            setShowPatientInfo={setShowPatientInfo}
            setAllSelectedDiagnosis={setAllSelectedDiagnosis}
            patientAppointmentID={patientAppointmentID}
            appointment={appointments}
            viewPatientDetail={viewPatientDetail}
            handleAddNoteId={handleAddNoteId}
            allAppointment={allAppointment}
          />         
        </CModalBody>
        <CModalFooter>
          <Button variant="outlined" onClick={() => setPatientModalVisible(false)}>
            Close
          </Button>
        </CModalFooter>
      </CModal>
    </div>
  )
}
export default DashboardFacility
